import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const e = t(
  (r, a) => /* @__PURE__ */ o.jsx(
    i,
    {
      ref: a,
      ...r,
      image: (s) => /* @__PURE__ */ o.jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 16,
          height: 16,
          fill: "none",
          viewBox: "0 0 16 16",
          ...s,
          children: [
            /* @__PURE__ */ o.jsx(
              "path",
              {
                fill: "currentColor",
                d: "M8 0a2 2 0 0 0-2 2v5a2 2 0 1 0 4 0V2a2 2 0 0 0-2-2"
              }
            ),
            /* @__PURE__ */ o.jsx(
              "path",
              {
                fill: "currentColor",
                d: "M4 7a4 4 0 1 0 8 0h2a6 6 0 0 1-5 5.917V15H7v-2.083A6 6 0 0 1 2 7z"
              }
            )
          ]
        }
      )
    }
  )
);
e.displayName = "MicIcon";
export {
  e as MicIcon,
  e as default
};
//# sourceMappingURL=index.js.map
